import store from '@/store'

/**
 * @author aocp
 * @date 2022-01-04
 */
export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const allPermission = '*_*_*'
    const permissions = store.getters && store.getters.acpermission

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value

      const hasPermissions = permissions.some((permission) => {
        return allPermission === permission || permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error('请设置操作权限标签值')
    }
  }
}
export function hasPermissions(value) {
  const allPermission = '*_*_*'
  const permissions = store.getters && store.getters.acpermission

  if (value && value instanceof Array && value.length > 0) {
    const permissionFlag = value

    const hasPermissions = permissions.some((permission) => {
      return allPermission === permission || permissionFlag.includes(permission)
    })
    return hasPermissions
  }
}
